module.exports = __webpack_public_path__ + "img/cheeseburger.305fe177.svg";